import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFormat'
})
export class CurrencyFormatPipe implements PipeTransform {

  transform(amount: number | string | null | undefined, currency: string = 'USD'): string {
    if (amount === null || amount === undefined || amount === '') return '-';
    
    try {
      const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
      
      if (isNaN(numericAmount)) {
        return '-';
      }

      const currencySymbol = this.getCurrencySymbol(currency);
      const formattedAmount = numericAmount.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });

      return `${currencySymbol} ${formattedAmount}`;
    } catch (error) {
      console.error('Error formatting currency:', error);
      return '-';
    }
  }

  private getCurrencySymbol(currency: string): string {
    const currencyMap: { [key: string]: string } = {
      'USD': '$',
      'usd': '$',
      'JPY': '¥',
      'jpy': '¥',
      'EUR': '€',
      'eur': '€',
      'GBP': '£',
      'gbp': '£',
      'AUD': 'A$',
      'aud': 'A$',
      'CAD': 'C$',
      'cad': 'C$'
    };

    return currencyMap[currency] || currency.toUpperCase();
  }
}
